<template>
  <div class="iframeWrapper">
    <iframe v-if="data && Object.keys(data).length !== 0" name="hosted-form"
            class="iframe"
            :data-sc-key="data.publicKey"
            :data-amount="data.amount"
            :data-currency="data.currency"
            :data-reference="data.reference"
            :data-redirect-url="data.redirectUrl"
            :data-color="data.color"
            :data-name="data.name"></iframe>
  </div>
</template>

<script>
export default {
  name: 'NbgIframe',
  props: {
    data: Object,
    currentCurrencyCode: String
  },
  beforeMount () {
    this.loadScript()
  },
  methods: {
    loadScript () {
      if (!this.scriptLoaded) {
        const script = document.createElement('script')
        script.src = 'https://simplify.com/commerce/simplify.pay.js'
        script.onload = () => {
          this.scriptLoaded = true
        }
        document.body.appendChild(script)
      }
    }
  }
}
</script>

<style scoped>
.iframeWrapper {
  width:100%;
  display: block;
  top: 0;
  left:0;
  position: absolute;
  backdrop-filter: blur(1rem);
  height: 100%;
  z-index: 999999;
}

.iframe {
  width: 100%;
  display: flex;
  padding-inline: 25%;
  height: 100%;
  top: 10%;
  position: relative;
}

@media (max-width: 720px) {
  .iframe {
    padding-inline: 0;
    top: 2%;
  }
}
</style>
